export {default} from './VolumeSlider';
